module.exports = __webpack_public_path__ + "static/media/YB5M10_05.0ab607cb.jpg";